import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaunchWalkthrough = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 134,
	height: 131,
	viewBox: "0 0 134 131",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M71.2979 103.498C99.2979 103.498 121.998 80.7977 121.998 52.6977C121.998 24.5977 99.1979 1.89771 71.2979 1.89771C43.2979 1.89771 20.5979 24.5977 20.5979 52.6977C20.5979 80.7977 43.2979 103.498 71.2979 103.498Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.148 85.4746C127.412 85.4746 129.248 83.639 129.248 81.3746C129.248 79.1102 127.412 77.2746 125.148 77.2746C122.884 77.2746 121.048 79.1102 121.048 81.3746C121.048 83.639 122.884 85.4746 125.148 85.4746Z",
			fill: "#EFF2F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.148 69.4746C132.694 69.4746 133.948 68.221 133.948 66.6746C133.948 65.1282 132.694 63.8746 131.148 63.8746C129.602 63.8746 128.348 65.1282 128.348 66.6746C128.348 68.221 129.602 69.4746 131.148 69.4746Z",
			fill: "#EFF2F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2979 19.2977C24.8443 19.2977 26.0979 18.0441 26.0979 16.4977C26.0979 14.9513 24.8443 13.6977 23.2979 13.6977C21.7515 13.6977 20.4979 14.9513 20.4979 16.4977C20.4979 18.0441 21.7515 19.2977 23.2979 19.2977Z",
			fill: "#EFF2F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.19792 73.2977C9.06981 73.2977 11.3979 70.9696 11.3979 68.0977C11.3979 65.2258 9.06981 62.8977 6.19792 62.8977C3.32604 62.8977 0.997925 65.2258 0.997925 68.0977C0.997925 70.9696 3.32604 73.2977 6.19792 73.2977Z",
			fill: "#EFF2F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.11 53.897L111.812 53.0825C112.008 53.0256 112.008 52.7415 111.812 52.6847L109.11 51.8701C109.04 51.8512 108.99 51.8007 108.971 51.7312L108.156 49.0351C108.1 48.8394 107.815 48.8394 107.759 49.0351L106.944 51.7312C106.925 51.8007 106.875 51.8512 106.805 51.8701L104.109 52.6847C103.913 52.7415 103.913 53.0256 104.109 53.0825L106.811 53.897C106.881 53.9159 106.931 53.9664 106.95 54.0359L107.765 56.7383C107.822 56.9341 108.106 56.9341 108.163 56.7383L108.977 54.0359C108.99 53.9664 109.04 53.9159 109.11 53.897Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.1098 24.8974L95.8123 24.0829C96.008 24.0261 96.008 23.742 95.8123 23.6851L93.1098 22.8706C93.0404 22.8517 92.9898 22.8012 92.9709 22.7317L92.1564 20.0357C92.0996 19.84 91.8154 19.84 91.7586 20.0357L90.9441 22.7317C90.9251 22.8012 90.8746 22.8517 90.8052 22.8706L88.109 23.6851C87.9133 23.742 87.9133 24.0261 88.109 24.0829L90.8115 24.8974C90.8809 24.9163 90.9314 24.9668 90.9504 25.0363L91.7649 27.7386C91.8217 27.9343 92.1059 27.9343 92.1627 27.7386L92.9772 25.0363C92.9898 24.9668 93.0404 24.9163 93.1098 24.8974Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.4664 28.2713L54.831 27.5586C55.0023 27.5089 55.0023 27.2603 54.831 27.2106L52.4664 26.4979C52.4056 26.4813 52.3614 26.4371 52.3448 26.3764L51.6321 24.0174C51.5824 23.8461 51.3338 23.8461 51.2841 24.0174L50.5714 26.3764C50.5548 26.4371 50.5106 26.4813 50.4498 26.4979L48.0907 27.2106C47.9194 27.2603 47.9194 27.5089 48.0907 27.5586L50.4553 28.2713C50.5161 28.2879 50.5603 28.3321 50.5769 28.3928L51.2896 30.7573C51.3393 30.9286 51.5879 30.9286 51.6377 30.7573L52.3504 28.3928C52.3614 28.3321 52.4056 28.2879 52.4664 28.2713Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.4664 71.6999L37.831 70.8854C38.0023 70.8286 38.0023 70.5445 37.831 70.4876L35.4664 69.6731C35.4056 69.6542 35.3614 69.6036 35.3448 69.5342L34.6321 66.8381C34.5824 66.6423 34.3338 66.6423 34.284 66.8381L33.5713 69.5342C33.5548 69.6036 33.5106 69.6542 33.4498 69.6731L31.0907 70.4876C30.9194 70.5445 30.9194 70.8286 31.0907 70.8854L33.4553 71.6999C33.5161 71.7189 33.5603 71.7694 33.5769 71.8388L34.2896 74.5413C34.3393 74.737 34.5879 74.737 34.6376 74.5413L35.3503 71.8388C35.3614 71.7694 35.4056 71.7189 35.4664 71.6999Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.6805 40.9027L33.3695 40.3936C33.4918 40.3581 33.4918 40.1805 33.3695 40.145L31.6805 39.636C31.6371 39.6241 31.6055 39.5926 31.5937 39.5492L31.0846 37.8642C31.0491 37.7419 30.8715 37.7419 30.836 37.8642L30.3269 39.5492C30.315 39.5926 30.2835 39.6241 30.2401 39.636L28.555 40.145C28.4326 40.1805 28.4326 40.3581 28.555 40.3936L30.244 40.9027C30.2874 40.9145 30.319 40.9461 30.3308 40.9895L30.8399 42.6784C30.8754 42.8007 31.053 42.8007 31.0885 42.6784L31.5976 40.9895C31.6055 40.9461 31.6371 40.9145 31.6805 40.9027Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.6801 57.6089L51.3691 57.0998C51.4914 57.0643 51.4914 56.8867 51.3691 56.8512L49.6801 56.3422C49.6367 56.3304 49.6051 56.2988 49.5933 56.2554L49.0842 54.5704C49.0487 54.4481 48.8711 54.4481 48.8356 54.5704L48.3265 56.2554C48.3146 56.2988 48.2831 56.3304 48.2397 56.3422L46.5546 56.8512C46.4322 56.8867 46.4322 57.0643 46.5546 57.0998L48.2436 57.6089C48.287 57.6207 48.3186 57.6523 48.3304 57.6957L48.8395 59.3846C48.875 59.5069 49.0526 59.5069 49.0881 59.3846L49.5972 57.6957C49.6051 57.6523 49.6367 57.6207 49.6801 57.6089Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.0019 10.0176L65.6909 9.50859C65.8133 9.47308 65.8133 9.29551 65.6909 9.25999L64.0019 8.75096C63.9585 8.73912 63.9269 8.70755 63.9151 8.66415L63.406 6.9792C63.3705 6.85687 63.1929 6.85687 63.1574 6.9792L62.6483 8.66415C62.6365 8.70755 62.6049 8.73912 62.5615 8.75096L60.8764 9.25999C60.7541 9.29551 60.7541 9.47308 60.8764 9.50859L62.5654 10.0176C62.6088 10.0295 62.6404 10.061 62.6522 10.1044L63.1613 11.7933C63.1968 11.9157 63.3744 11.9157 63.4099 11.7933L63.919 10.1044C63.9269 10.061 63.9585 10.0295 64.0019 10.0176Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.025 82.3684L105.714 81.8593C105.836 81.8238 105.836 81.6462 105.714 81.6107L104.025 81.1017C103.981 81.0898 103.95 81.0583 103.938 81.0149L103.429 79.3299C103.393 79.2076 103.216 79.2076 103.18 79.3299L102.671 81.0149C102.659 81.0583 102.628 81.0898 102.584 81.1017L100.899 81.6107C100.777 81.6462 100.777 81.8238 100.899 81.8593L102.588 82.3684C102.632 82.3802 102.663 82.4118 102.675 82.4552L103.184 84.1441C103.22 84.2664 103.397 84.2664 103.433 84.1441L103.942 82.4552C103.95 82.4118 103.981 82.3802 104.025 82.3684Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.3634 60.4484C52.1107 63.5468 46.5214 68.0425 46.5214 71.9915C46.5214 74.3044 46.5214 77.5967 46.5214 79.9278C46.5214 80.8695 47.8703 81.4389 48.6489 80.9091C50.7005 79.5129 54.2477 77.9044 59.3403 78.3706C67.9672 79.1604 57.8215 64.7011 57.8215 64.7011L56.3634 60.4484Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.2868 60.4484C91.5395 63.6076 97.1288 68.0425 97.1288 71.9915C97.1288 74.3044 97.1288 77.5967 97.1288 79.9278C97.1288 80.8695 95.7798 81.4389 95.0013 80.9091C92.9496 79.5129 89.4025 77.9044 84.3098 78.3706C75.6829 79.1604 85.8287 64.7011 85.8287 64.7011L87.2868 60.4484Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.7947 16.9491C63.7753 22.6599 54.1763 36.6939 55.9381 54.5553C57.6392 72.4168 59.158 81.226 62.4387 83.3523C65.7801 85.4787 69.0608 85.9647 71.7947 85.9647C74.5286 85.9647 77.8093 85.4787 81.1507 83.3523C84.4921 81.226 85.9502 72.4168 87.6513 54.5553C89.3524 36.6939 79.7534 22.6599 71.7947 16.9491Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.87 88.4556H65.7194C64.7473 88.4556 64.0183 87.6658 64.0183 86.7545V83.7776H79.6319V86.6938C79.5711 87.6658 78.7813 88.4556 77.87 88.4556Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.6452 58.4763H70.9442V80.8943H72.6452V58.4763Z",
			fill: "#D6DCE8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.7947 47.2649C75.1164 47.2649 77.8093 44.5721 77.8093 41.2504C77.8093 37.9286 75.1164 35.2358 71.7947 35.2358C68.4729 35.2358 65.7801 37.9286 65.7801 41.2504C65.7801 44.5721 68.4729 47.2649 71.7947 47.2649Z",
			stroke: "#9FA8BA",
			strokeWidth: 4,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.4124 102.412C79.4124 106.942 75.7775 129.646 71.2479 129.646C66.7182 129.646 63.0833 106.942 63.0833 102.412C63.0833 97.8828 66.7182 94.2479 71.2479 94.2479C75.7775 94.2479 79.4124 97.9388 79.4124 102.412Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0066 117.174C71.7453 117.984 70.7458 117.985 70.4838 117.176C69.0974 112.892 67.7808 105.626 67.7808 103.028C67.7808 101.126 69.3466 99.5605 71.2479 99.5605C73.1492 99.5605 74.715 101.126 74.715 103.028C74.715 105.629 73.395 112.871 72.0066 117.174Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
export { SvgLaunchWalkthrough as ReactComponent };
